module.exports = __webpack_public_path__ + "img/CHEVRON_BOTTOM.125509e6.svg";